import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
const app = createApp(App);
console.log('Router in main.ts:', router);
app.use(router);
app.mount('#app');
